<!-- Back to home -->
<div class="back-home">
  <button type="button" class="btn btn-sm pl-0 ml-0" [routerLink]="'../..'">
    <span><i class="icon icon-arrow-back-breadcrumb text-uppercase" aria-hidden="true"></i>{{back}}</span>
  </button>
</div>

<!-- Topic information -->
<div class="mb-5">
  <app-topic-info *ngIf="!!asset" [topic]="asset"></app-topic-info>
</div>

<!-- Files dashboard -->
<div class="mb-5" *ngIf="!!asset?.files?.length">
  <!-- Tile view -->
  <div class="col col-4 pl-0 pr-0">
    <app-dropdown-sort (select)="onColumnSort($event)"></app-dropdown-sort>
  </div>
  <div class="file-tiles">
      <app-asset-tile *ngFor="let file of asset.files" class="tile" [data]="file" [showDelete]="false" (setThumbnail)="onSetThumbnail($event)"></app-asset-tile>
  </div>
</div>

